import moment from "moment";
import React from "react";

function successMessage(toast,message){
      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });
    }
    
    function errorMessage(toast,message){
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });
    }

    const closeAllActive = () => {
      const childEles = document.getElementById("list-account-info").querySelectorAll('.toggle-message-add');
      const activeAc = document.getElementById("list-account-info").querySelectorAll('.active-ac');
      for (let x = 0; x < childEles.length; x++) {
        childEles[x].classList.remove("toggle-message-add");
      }
      for (let x = 0; x < activeAc.length; x++) {
        activeAc[x].classList.remove("active-ac");
      }
    }

    export {
        successMessage,
        errorMessage,
        closeAllActive
    }